import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // 更新狀態以顯示 fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // 可以在這裡 log 到錯誤追蹤服務
    console.error("ErrorBoundary caught an error", error, errorInfo);
    alert(`ErrorBoundary caught an error: ${error}, ${errorInfo}`);
  }

  render() {
    if (this.state.hasError) {
      return <div>⚠️ 發生錯誤，請重新整理頁面。</div>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
